import { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Context } from "../context/AppContext";

const ScrollTop = () => {
  const [value, setValue] = useState(0);
  const scrollRef = useRef(null);
  const { pathname } = useLocation();
  const { setHeaderSidebar } = useContext(Context);

  const ScrollButton = () => {
    const scrollHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    const scrolled = scrollHeight > 0 ? (window.scrollY / scrollHeight) * 307.919 : 0;
    setValue(scrolled);
    if (window.scrollY > 30) {
      scrollRef.current?.classList.add("active-progress");
    } else {
      scrollRef.current?.classList.remove("active-progress");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", ScrollButton);
    return () => {
      window.removeEventListener("scroll", ScrollButton);
    };
  }, []);

  useEffect(() => {
    setHeaderSidebar(false);
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());

    // Scroll after paint so newly mounted pages (and Swiper) lay out correctly
    const id = window.requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
    return () => window.cancelAnimationFrame(id);
  }, [pathname, setHeaderSidebar]);

  return (
    <>
      <div
        className="scroltop-progress scroltop-primary"
        ref={scrollRef}
        onClick={() => {
          window.scrollTo(0, 0);
        }}
      >
        <svg width="100%" height="100%" viewBox="-1 -1 102 102">
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: ".5s linear",
              strokeDasharray: "307px",
              strokeDashoffset: `${value - 307.919}px`,
            }}
          />
        </svg>
      </div>
    </>
  );
};

export default ScrollTop;
